var map = {
	"./community/club.png": "4795",
	"./community/groupbuy.png": "d350",
	"./community/hzxy_qr.png": "9c8e",
	"./community/preach.png": "af2c",
	"./community/txsb_qr.png": "e458",
	"./community/zrnf_qr.png": "4824",
	"./doubleQuotes.png": "0d23",
	"./framing/r_book.png": "0de1",
	"./framing/r_figure_01.png": "b31a",
	"./framing/r_figure_02.png": "eeda",
	"./framing/r_figure_03.png": "b816",
	"./framing/r_figure_04.png": "c622",
	"./framing/r_figure_05.png": "f9bb",
	"./framing/r_figure_06.png": "0cd1",
	"./framing/r_movie.png": "9c01",
	"./guinong/audio.png": "6f79",
	"./guinong/book.png": "13f8",
	"./guinong/desire_icon_01.png": "a315",
	"./guinong/desire_icon_02.png": "2141",
	"./guinong/desire_icon_03.png": "ccd6",
	"./header_logo.png": "57ab",
	"./home/bg.png": "1cc0",
	"./home/home_play_bg.png": "9f74",
	"./home/videoPlay.png": "6ee5",
	"./introduce/a_01.png": "2800",
	"./introduce/bit_system_normal.png": "057fb",
	"./introduce/bit_system_selected.png": "f1b0",
	"./introduce/btn_buy_normal.png": "d16f",
	"./introduce/btn_buy_selected.png": "ba17",
	"./introduce/btn_shopping_cart_normal.png": "60ac",
	"./introduce/btn_shopping_cart_selected.png": "6a66",
	"./introduce/d_jxc.jpg": "1316",
	"./introduce/d_shc.jpg": "bb06",
	"./introduce/d_xac.jpg": "3a4e",
	"./introduce/d_zjc.jpg": "9010",
	"./introduce/d_zycc.jpg": "0c1c",
	"./introduce/g_01.png": "ad8a",
	"./introduce/g_02.png": "0108",
	"./introduce/i_01.png": "5227",
	"./introduce/i_02.png": "f9a7",
	"./introduce/i_03.png": "e54a",
	"./introduce/i_04.png": "efe8",
	"./introduce/i_page.png": "a74c",
	"./introduce/l_01.png": "4438",
	"./introduce/xyimg.png": "5f5f",
	"./logo.jpg": "b640",
	"./logos/gn.png": "6fce",
	"./logos/gt.png": "a0ff",
	"./logos/hzxc.png": "d78f",
	"./logos/hzzy.png": "469a",
	"./logos/txsb.png": "f9aa",
	"./logos/wf.png": "4026",
	"./mallApp/app_android_normal.png": "0831",
	"./mallApp/app_android_selected.png": "f7eb",
	"./mallApp/app_bg.png": "24ef",
	"./mallApp/app_ios_normal.png": "b9c4",
	"./mallApp/app_ios_selected.png": "49c3",
	"./mobile/footer_logo.png": "f429",
	"./mobile/introduce/d_01.png": "c4f1",
	"./mobile/introduce/d_02.png": "f42c",
	"./mobile/introduce/d_03.png": "13ed",
	"./mobile/introduce/d_04.png": "7f06",
	"./mobile/menus/page_01.png": "a3b7",
	"./mobile/menus/page_02.png": "1081",
	"./mobile/menus/page_03.png": "37d5",
	"./mobile/menus/page_04.png": "9d50",
	"./mobile/menus/page_05.png": "5bff",
	"./mobile/menus/page_11.png": "3b7d",
	"./mobile/menus/page_12.png": "55c6",
	"./mobile/menus/page_13.png": "9590",
	"./mobile/menus/page_14.png": "2411",
	"./mobile/menus/page_15.png": "e448",
	"./mobile/menus/page_31.png": "65a8",
	"./mobile/menus/page_32.png": "a078",
	"./mobile/menus/page_33.png": "a6fd",
	"./mobile/menus/page_34.png": "7017",
	"./mobile/menus/page_41.png": "9d99",
	"./mobile/menus/page_42.png": "e6cc",
	"./mobile/wechat.png": "685d",
	"./news/2015.png": "ec7d",
	"./news/2016.png": "87f6",
	"./news/2018.png": "ca13",
	"./news/2019.png": "e392",
	"./news/2020.png": "dca0",
	"./news/2021.png": "2275",
	"./painter/cf.jpg": "a0a3",
	"./painter/cwp.jpg": "64ac",
	"./painter/dk.jpg": "d07e",
	"./painter/hzh.jpg": "0b99",
	"./painter/lyx.jpg": "4a60",
	"./painter/pjb.jpg": "c5f5",
	"./painter/shy.jpg": "5d72",
	"./painter/tcj.jpg": "c5b1",
	"./painter/wh.jpg": "ad30",
	"./painter/wt.jpg": "9c85",
	"./painter/yxy.jpg": "a123",
	"./painter/zgh.jpg": "cddb",
	"./painter/zql.jpg": "152a",
	"./painter/zxs.jpg": "26df",
	"./product/1.jpg": "d7eb",
	"./product/10.jpg": "4666",
	"./product/11.jpg": "4682",
	"./product/12.jpg": "7bc2",
	"./product/13.jpg": "891d",
	"./product/14.jpg": "d28e",
	"./product/15.jpg": "0db1",
	"./product/16.png": "8093",
	"./product/17.png": "93be",
	"./product/18.png": "0d3e",
	"./product/2.jpg": "277c",
	"./product/3.jpg": "792c",
	"./product/4.jpg": "b331",
	"./product/5.jpg": "3015",
	"./product/6.jpg": "3146",
	"./product/7.jpg": "3bcf",
	"./product/8.jpg": "27e3",
	"./product/9.jpg": "de42",
	"./product/WFJM/e5bc8ec46bcf4b4a75936dda3043597.jpg": "b97d",
	"./product/WFJM/e7bc21176ce3f21d21424eb205e1e6a.jpg": "42a1",
	"./product/万非芦荟膏/0cd1000d08c313eeafc18c543aea381.jpg": "ac3d",
	"./product/万非芦荟膏/1c719f9146f7eb75ef327dfc4eef8c7.jpg": "657b",
	"./product/万非芦荟膏/884cdd398e5b906e4ab34e3455b0611.jpg": "266a",
	"./product/修护面霜/3174f6889d8777fe7bbbdbbb18b8751.jpg": "ffdd",
	"./product/沐浴露/228ab98e90e5c16bb3700cb3a13062a.jpg": "880d",
	"./product/洗衣液/070c8288d208c5d4ca1ee3f4d07e3ed.jpg": "ff8c",
	"./product/洗衣液/c518472f1824e55ae8c59fdec93fa50.jpg": "c06c",
	"./product/洗衣液/fef24e9c852e6f7261570317e6726ad.jpg": "654a",
	"./product/牙膏/1682b40c5e10c9dd5726bde79aea0d3.jpg": "c1b9",
	"./product/牙膏/97c44a47f653ff3b2ebad95d391eacb.jpg": "4469",
	"./product/牙膏/fc63c156256fa0d49206dd4850485e3.jpg": "15aa",
	"./product/芦荟精华/206590fe22ac2a1d926a16664850ca8.jpg": "e367",
	"./product/芦荟精华/30f6a9c8ddcd42c6d9133cb5b0e37f5.jpg": "8219",
	"./product/芦荟精华/c95f37d2b890ee517b3fc68d7d831c4.jpg": "adae",
	"./product/蕙芷/d0b1dfaab2e3f3e2f2319232f433100.jpg": "7852",
	"./product/蕙芷/d8b9930dd774e0d22297bc60c8a2ecc.jpg": "41c4",
	"./product/蕙芷美容皂/a3132abbb82a173a9c9875982e52829.jpg": "5bbf",
	"./product/蕙芷美容皂/ab94e24a470c11801eafd63cb273a87.jpg": "0af3",
	"./product/蕙芷美容皂/d11b85c983a95f7f6696972ae9e3f1d.jpg": "c52e",
	"./product/雪梨膏/0967fb571f37761ef488e9feec280c5.jpg": "742a",
	"./product/雪梨膏/c35e3a6dfdc6cedaa6da20d9a78f18c.jpg": "7d8e",
	"./product/雪梨膏/d1fe1dadadc06227d1d8b9482895edc.jpg": "2dd4",
	"./product/青汁/5851e2ce132b57105a78ce114fae76a.jpg": "d1fd",
	"./product/青汁/bc9326f866f77f18d1ccdccc26896da.jpg": "94c6",
	"./products/1/1-1/883a19f41ac27a0a9061278cb036834.jpg": "1760",
	"./products/1/1-1/8dcd0d89d526385dc5108ee947a7fbd.jpg": "1ffd",
	"./products/1/1-2/e5e088c2a3865702fc36c9276f41f4f.jpg": "d24a",
	"./products/1/1-3/19b75094b88310b6aeaccd0fecadb5e.jpg": "a97e",
	"./products/1/1-3/5b7f80888280d915456ec136d1e18b1.jpg": "c9a5",
	"./products/1/1-3/dc14ebc8c9ee8860bc69ea8ec528ab6.jpg": "22bd",
	"./products/1/1-4/38888291ec72bfb1fbaffd3fcaec335.jpg": "a047",
	"./products/1/1-5/bca0311d4178463853c3f73d3015e4b.jpg": "8c3e",
	"./products/1/1-6/39323e3fbf13e0ce35ca93581f31720.jpg": "d1b2",
	"./products/1/1-6/8245b9546eb6e6bce9360af29c8b453.jpg": "41f5",
	"./products/2/2-1/05107e4b6d0c1215a62cf96c09b7516.jpg": "cefb",
	"./products/2/2-1/3ca48fbe89bfd475e7a0e6c34304759.jpg": "0a28",
	"./products/2/2-2/50026ff866bc53f67f55cd6760b0097.jpg": "8174",
	"./publicWelfare/gygx_01.jpg": "003f",
	"./publicWelfare/gygx_02.jpg": "9771",
	"./publicWelfare/gygx_03.jpg": "6fd2",
	"./publicWelfare/gygx_04.jpg": "1319",
	"./publicWelfare/gygx_05.jpg": "3440",
	"./publicWelfare/gygx_06.jpg": "6efa",
	"./publicWelfare/gygx_07.jpg": "37e4",
	"./publicWelfare/gygx_08.jpg": "fa78",
	"./publicWelfare/gygx_09.jpg": "5dda",
	"./qrcode.png": "10a6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";